import { useDisclosure } from "@mantine/hooks";
import { IconHistory } from "@tabler/icons-react";
import { useCallback } from "react";
import { useGetApi } from "src/hooks";
import { StyledActionIcon } from "src/styled";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

import { type IMedHistoryItem } from "./MedHistory.types";
import MedHistoryModal from "./MedHistoryModal";

interface Props {
  tag: string;
}

const getInputValueByTag = (tag: string) =>
  (
    document
      .querySelector(`div.${tag}`)
      ?.querySelector("input[type='search']") as HTMLInputElement
  )?.value;

const mapper = (data: any): IMedHistoryItem[] => data.list;

const MedHistoryButton = ({ tag }: Props) => {
  const [opened, { open, close }] = useDisclosure();

  const {
    data,
    refetch: fetchHistory,
    isLoading,
  } = useGetApi({
    request: "get-supplement-history",
    fetchOnInit: false,
    mapper,
  });

  const handleHistory = useCallback(async () => {
    const fname = getInputValueByTag("med_fname");
    const sname = getInputValueByTag("med_sname");
    const dob = getInputValueByTag("med_dob");
    if (!fname || !sname) {
      Notification("Unavailable", "You must first select a patient", "yellow");
      return;
    }

    await fetchHistory({
      params: { fname, sname, dob, tag, yachtid: getYachtId() },
    });
    open();
  }, [fetchHistory, open, tag]);

  return (
    <>
      <StyledActionIcon onClick={handleHistory} loading={isLoading}>
        <IconHistory />
      </StyledActionIcon>
      <MedHistoryModal opened={opened} onClose={close} tag={tag} data={data} />
    </>
  );
};

export default MedHistoryButton;
